import {
  Originator,
  OriginatorDating,
  OriginatorEvent,
  OriginatorReference,
} from 'types';
import { isValidString } from '.';

export const constructOriginatorEventLabel = (
  event: OriginatorEvent
): string => {
  const formatFrom = event.begin ? `, od: ${event.begin}` : '';
  const formatTo = event.end ? `, do: ${event.end}` : '';
  const formatStudyStatus = event.studyStatusLabel
    ? `, ${event.studyStatusLabel}`
    : '';
  return `${event.typeLabel}${formatFrom}${formatTo}${formatStudyStatus}`;
};

export const constructDatingString = (dating: OriginatorDating): string =>
  `${dating?.methodLabel ?? ''}${
    dating?.date ? `${dating?.methodLabel ? ', ' : ''}${dating?.date}` : ''
  }`;

export const constructRelationLink = (
  relatedEntity: OriginatorReference
): string =>
  `/rejstriky/all/${relatedEntity?.preferredName?.label}/0/10/${relatedEntity?.id}`;

/**
 * TODO: refactor
 */
export const constructOriginatorLabel = (
  originator: Originator | OriginatorReference
): string => {
  if (!originator.preferredName) {
    return originator.id ?? '--';
  }
  const { originatorClass } = originator;

  if (
    originatorClass === 'PERSON' ||
    originatorClass === 'EVENT' ||
    originatorClass === 'PARTY_GROUP'
  ) {
    return (
      originator.preferredName?.label ??
      `${originator.preferredName?.primaryPart ?? ''} ${
        originator.preferredName?.secondaryPart ?? ''
      }` ??
      ''
    );
  }

  if (originatorClass === 'DYNASTY') {
    return `${originator.preferredName?.label ?? ''} (rod/rodina)`;
  }

  const {
    geoSupplement,
    generalSupplement,
    chronologicalSupplement,
    primaryPart,
  } = originator.preferredName;
  const formattedGeneralSuplement = generalSupplement
    ? `${generalSupplement}`
    : '';

  const formattedGeoSupplement = geoSupplement ? `${geoSupplement}` : '';

  const formattedChronologicalSupplement = chronologicalSupplement
    ? `${formattedGeoSupplement ? ': ' : ''}${chronologicalSupplement}`
    : '';

  const formattedSecondaryPart =
    isValidString(formattedGeneralSuplement) ||
    isValidString(formattedGeoSupplement) ||
    isValidString(formattedChronologicalSupplement)
      ? `(${formattedGeneralSuplement}${
          formattedGeneralSuplement && formattedGeoSupplement ? ': ' : ''
        }${formattedGeoSupplement}${formattedChronologicalSupplement})`
      : '';
  return `${primaryPart ?? ''} ${formattedSecondaryPart}`;
};
